<template>
    <div>
      <add-currency :is-active.sync="isAdding" @changed="currencyAdded" />
      <add-currency
        :is-active.sync="isUpdating"
        method="put"
        :currency="editingCurrency"
        @changed="currencyUpdated"
      />
      <data-table 
        title="Currencies" 
        ref="table" 
        :url="url" 
        :headers="headers" 
        :archive="false"
        item-key="id"
        searchable
        >
        <template slot="action.icons">
          <v-btn color="primary" @click="isAdding = true">
            <v-icon color="light-blue lighten-4">
              mdi-plus-outline
            </v-icon>
            Add New Currency
          </v-btn>
        </template>
        <template slot="item.actions" slot-scope="{ item }">
          <div class="d-flex">
            <v-btn small icon @click.stop="updateCurrency(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn small icon @click.stop="deleteCurrency(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </data-table>
    </div>
  </template>
  
  <script>
  import AddCurrency from "./form";
  
  export default {
    components: { AddCurrency },
    data() {
      return {
        isAdding: false,
        isUpdating: false,
        url: "/api/v1/payment-currencies",
        editingCurrency: null,
        headers: {
          name: "Name",
          code: "Code",
          symbol: "Symbol",
          exchange_rate: "Euro exchange rate",
          actions: "Actions",
        },
      };
    },
    watch: {
      url() {
        this.$nextTick(() => {
          this.$refs.table.fetchData();
        });
      },
    },
    methods: {
      currencyAdded({ message }) {
        this.isAdding = false;
        Notify.success(message);
        // refresh the table data
        this.$refs.table.fetchData();
      },
      currencyUpdated({ message }) {
        this.editingCurrency = null;
        this.isUpdating = false;
        Notify.success(message);
        // refresh the table data
        this.$refs.table.fetchData();
      },
      updateCurrency(type) {
        this.editingCurrency = Object.assign({}, type);
        this.isUpdating = true;
      },
      deleteCurrency(level) {
        Notify.confirm(`Please Confirm`).then(() => {
          this.$http
            .delete(`/api/v1/payment-currencies/${level.id}`)
            .then((result) => {
              Notify.success(result.message);
              window.location.reload();
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error) => {
              Notify.error(error.message);
            });
        });
      },
    },
  };
  </script>
  